import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { USER_FACING_ERROR_I18N_KEYS } from '../../constants';
/**
 * React 渲染树崩溃后的友好兜底页。
 * 不依赖 Redux（store 可能已不可用），仅展示通用文案与刷新入口。
 * 不展示任何异常堆栈或技术细节。
 *
 * TODO: 错误提示交互（自动重试、反馈入口等）待完善。
 *
 * @returns {JSX.Element}
 */
function AppCrashFallback() {
    const { t } = useTranslation();
    const onReload = useCallback(() => {
        window.location.reload();
    }, []);
    return (React.createElement("div", { className: 'overlay__container', id: 'app-crash-fallback', role: 'alert' },
        React.createElement("div", { className: 'overlay__content' },
            React.createElement("div", { className: 'inlay' },
                React.createElement("span", { className: 'reload_overlay_title', id: 'app_crash_title' }, t(USER_FACING_ERROR_I18N_KEYS.APP_CRASH_TITLE)),
                React.createElement("span", { className: 'reload_overlay_text', id: 'app_crash_message' }, t(USER_FACING_ERROR_I18N_KEYS.APP_CRASH_MESSAGE)),
                React.createElement("div", { style: { marginTop: 16, textAlign: 'center' } },
                    React.createElement("button", { className: 'primary', id: 'app_crash_reload', onClick: onReload, type: 'button' }, t(USER_FACING_ERROR_I18N_KEYS.RELOAD)))))));
}
export default AppCrashFallback;
